export default function($) {
  const closeDropdowns = () => {
    const dropdowns = document.querySelectorAll('[id^="product-dropdown-"], [id^="activity-dropdown-"]');
    dropdowns.forEach(dropdown => {
      dropdown.classList.add('hidden');
      const button = document.querySelector(`[aria-controls="${dropdown.id}"]`);
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  };

  // Ouvrir la recherche
  $('.js-search-trigger').on('click', function() {
    $('.js-search-overlay').css('display', 'flex');
    $('.js-search-overlay').find('input').focus();
  });

  // Fermer la recherche et les dropdowns
  $('.js-search-close').on('click', function() {
    $('.js-search-overlay').hide();
    closeDropdowns();
  });
}
